import { Grid, Cell } from 'components/Grid';
import styles from './latestProducts.scss';
import { NO_ELEMENT, hasElements } from 'utils';
import { Section } from 'components/Section';
import {
  isMobile as isMobileSelector,
  isTabletLayout as isTabletLayoutSelector
} from 'components/Shared/responsive';
import { ProductCard } from 'components/Shared/Product/themes/BGH/productCard';
import { LatestProductsBlock } from 'models/LatestProductsBlock';
import { ProductlistViewProduct } from 'models/ProductlistViewProduct';
import { SrcSet } from 'components/Shared/Image/SrcSet';
import { Appearances } from 'models/SectionBlock';
import { useSelector } from 'react-redux';

const MOBILE_WIDTH = 181;
const DESKTOP_WIDTH = 282;
const IMAGE_MARGIN = 2;

const picture = {
  height: DESKTOP_WIDTH + IMAGE_MARGIN,
  width: DESKTOP_WIDTH + IMAGE_MARGIN
};

const sizes: { [key: string]: SrcSet } = {
  default: {
    viewWidth: MOBILE_WIDTH,
    width: MOBILE_WIDTH,
    height: MOBILE_WIDTH
  },
  medium: {
    viewWidth: DESKTOP_WIDTH,
    width: DESKTOP_WIDTH,
    height: DESKTOP_WIDTH
  }
};

const getAmountOfProducts = ({
  isMobile,
  isTabletLayout
}: Pick<MergedProps, 'isMobile' | 'isTabletLayout'>): number => {
  const AMOUNT_OF_PRODUCTS_MOBILE = 2;
  const AMOUNT_OF_PRODUCTS_TABLET = 4;
  const AMOUNT_OF_PRODUCTS_DESKTOP = 6;

  if (isMobile) {
    return AMOUNT_OF_PRODUCTS_MOBILE;
  }

  if (isTabletLayout) {
    return AMOUNT_OF_PRODUCTS_TABLET;
  }

  return AMOUNT_OF_PRODUCTS_DESKTOP;
};

interface MergedProps extends LatestProductsBlock {
  isMobile: boolean;
  isTabletLayout: boolean;
}

export const LatestProducts = ({ products, title }: MergedProps) => {
  const isMobile = useSelector(isMobileSelector);
  const isTabletLayout = useSelector(isTabletLayoutSelector);

  if (!hasElements(products)) {
    return NO_ELEMENT;
  }

  const amountOfProducts = getAmountOfProducts({ isMobile, isTabletLayout });

  const content = products
    .slice(0, amountOfProducts)
    .map((product: ProductlistViewProduct, index: number) => (
      <Cell key={index}>
        <ProductCard isCategoryBold {...product} picture={picture} customSizes={sizes} />
      </Cell>
    ));

  return (
    <Section title={title} isDesktop={!isMobile} appearance={Appearances.Tertiary} isClear>
      <Grid
        huge="6"
        tablet="4"
        desktop="5"
        phone="2"
        gutters={isMobile ? 'large' : 'medium'}
        className={styles.gridStyling}
      >
        {content}
      </Grid>
    </Section>
  );
};
